import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Одноцветная приталенная футболка с контрастной резинкой на горловине и манжетах, представленная в разных цветовых комбинациях. Пошив с добавлением эластана обеспечивает большую мягкость ткани. За счет вплетения в ткань резиновой нити футболка прекрасно держит форму и не растягивается. Плотность материала от 155гр/м<sup>2</sup> до 200гр/м<sup>2</sup> гарантирует качественное нанесение изображений.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}${maintenance}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`ringer_man_tee`],
      sizeInfo: `ringer_man_tee`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
